export const BE_KEY = {
	data: 'data',
	meta: 'meta',
	success: 'success',
	fail: 'fail',
	message: 'message',
	error: 'error'
}